import React from "react";
import { CreateContainer } from "./ContainerCreate";
import LoadMoreContainer from "./LoadMoreContainer";
import { getFileUnderPosts } from "../api/getFileUnderPosts";

const PER_PAGE = 30;

class FileUnderContainer extends LoadMoreContainer {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: false, items: [] };
  }
  componentWillReceiveProps(nextProps) {
    const { slug: nextSlug } = nextProps;
    const { slug } = this.props;
    if (nextSlug !== slug) {
      this.fetch(nextSlug, 1);
      this.state = { page: 1, loading: true, hasMore: false, items: [] };
    }
  }
  fetch = (slug, page) => {
    this.props.request(slug, page).then(({ data }) => {
      const items = this.state.items.slice(0);
      data.posts.map((t) => items.push(t));

      const total = (data && data.total) || 0;
      const tagName = (data && data.tag) || "";
      const hasMore = !!(total >= PER_PAGE);
      this.setState({ items, tagName, page: (this.state.page += 1), total, hasMore });
    });
  };
}

FileUnderContainer.defaultProps = {};
export default CreateContainer(getFileUnderPosts, FileUnderContainer);
